import AudioPlayerIns from "@/component/AudioPlayer/AudioPlayerIns";
import { VideoPlayerIns } from "@/sections/MobileSummary/VideoPlayer/VideoPlayerIns";
import { create } from "zustand";
import { subscribeWithSelector } from "zustand/middleware";

interface AVPlayerState {
  videoPlayerIns: VideoPlayerIns | null;
  audioPlayerIns: AudioPlayerIns | null;
  playingTime: number;
  playingPi: string;
  playingSi: string;
  isAudioPlaying: boolean;
}

interface AVPlayerStore extends AVPlayerState {
  setVideoPlayerIns: (videoPlayerIns: VideoPlayerIns) => void;
  setAudioPlayerIns: (audioPlayerIns: AudioPlayerIns) => void;
  updatePlayingTime: (time: number) => void;
  updatePlayingPi: (pi: string) => void;
  updatePlayingSi: (playingSi: string) => void;
  setIsAudioPlaying: (isAudioPlaying: boolean) => void;
  initStore: () => void;
}

const avPlayerState: AVPlayerState = {
  videoPlayerIns: null,
  audioPlayerIns: null,
  playingTime: 0,
  playingSi: "",
  playingPi: "",
  isAudioPlaying: false,
};

const avPlayerStore = create(
  subscribeWithSelector<AVPlayerStore>((set) => ({
    ...avPlayerState,
    initStore: () => {
      set({ ...avPlayerState });
    },
    setVideoPlayerIns: (videoPlayerIns) => {
      set({ videoPlayerIns });
    },
    setAudioPlayerIns: (audioPlayerIns: AudioPlayerIns) => {
      set({ audioPlayerIns });
    },
    updatePlayingTime: (time) => {
      set({ playingTime: time });
    },
    updatePlayingSi: (playingSi) => {
      set({ playingSi });
    },
    updatePlayingPi: (pi) => {
      set({ playingPi: pi });
    },
    setIsAudioPlaying: (isAudioPlaying) => {
      set({ isAudioPlaying });
    },
  }))
);

export default avPlayerStore;
